export default __webpack_public_path__ + "static/news1-89781d5b2f39f2de51aaf4de783797b8.jpg";